import { FC, Fragment, useEffect } from 'react';
import { connect } from 'react-redux';
import { AnyAction, bindActionCreators, Dispatch } from 'redux';
import { FormattedMessage } from 'react-intl';
import * as modalWindowActions from 'root/modal/modalWindowActions';
import { MinimalUser, ReduxState } from 'types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUserTimes, } from '@fortawesome/free-solid-svg-icons';
import { companyUsersSliceActions } from 'features/users/companyUsersSlice';
import { ActionStatusDisplayer } from 'components/ActionStatusDisplayer';
import { formatMessage } from 'i18n/CurrentLocale';


export const DeleteUserModal: FC<Props> = (props) => {

    const { userUpdateStatus } = props;
    const { user } = props.modalData;
    const { publicId } = user;

    useEffect(() => {
        props.clearUserUpdateStatus();
    }, []);

    const actionStatusHasChanged = !!(userUpdateStatus.loading || userUpdateStatus.succeeded || userUpdateStatus.error);

    return (
        <div className="panel radius-rectangle full-width-form confirmation-modal">
            <div className="panel-header">
                <h2 className="bold-title">
                    <FontAwesomeIcon icon={faUserTimes} size='sm' /><FormattedMessage id="MODAL_DELETE_USER_TITLE" />
                </h2>
                <button className="btn-close-modal" data-testid='btn-close-modal' onClick={() => props.closeModal()} />
            </div>

            <div className="panel-content">
                {actionStatusHasChanged
                    ? <>
                        <ActionStatusDisplayer
                            status={userUpdateStatus}
                            succeededMessage={formatMessage({ id: 'MODAL_DELETE_USER_ACTION_SUCCEEDED' })}
                            errorMessage={formatMessage({ id: 'MODAL_DELETE_USER_ACTION_ERROR' })}
                        />
                        <button className='btn-blue' onClick={() => props.closeModal()}>
                            <FormattedMessage id='GLOBAL_CLOSE' />
                        </button>
                    </>
                    : <Fragment>
                        <FormattedMessage id="MODAL_DELETE_USER_TEXT"
                            values={{
                                b: chunks => <strong>{chunks}</strong>,
                                fullName: `${user.givenName} ${user.familyName}`,
                            }}
                        />
                        <div className="row-7">
                            <div className="col-6">
                                <button className="btn-cancel" onClick={() => props.closeModal()}>
                                    <FormattedMessage id="GLOBAL_CANCEL" />
                                </button>
                            </div>
                            <div className="col-6">
                                <button className="btn-red" onClick={() => props.deleteUser({ userPublicId: publicId })}>
                                    <FormattedMessage id="GLOBAL_DELETE" />
                                </button>
                            </div>
                        </div>
                    </Fragment>
                }
            </div>
        </div>
    );
};


type OwnProps = {
    modalData: { user: MinimalUser }
};
type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = ReturnType<typeof mapDispatchToProps>;
type Props = StateProps & DispatchProps & OwnProps;

function mapStateToProps(state: ReduxState) {
    return {
        userUpdateStatus: state.companyUsers.userUpdateStatus
    };
}

function mapDispatchToProps(dispatch: Dispatch<AnyAction>) {
    return bindActionCreators({
        deleteUser: companyUsersSliceActions.deleteCompanyUser,
        clearUserUpdateStatus: companyUsersSliceActions.clearUserUpdateStatus,
        closeModal: modalWindowActions.closeModal
    }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(DeleteUserModal);
